import './Index.scss';

import { AppHeader } from '@ui/header';
import { CreateInitiativeNotifications } from './initiatives/notifications';
import { CreateTaskNotification } from '@initiatives/detail/tasks';
import { DashboardView } from './dashboard/DashboardView';
import { DataDictionaryView } from './data-dictionary/DataDictionaryView';
import { DataSecurityView } from './data-security/DataSecurityView';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FeatureRouteWrapper } from '@ui/features';
import { InitiativesIndex } from './initiatives/Index';
import { IssuesView } from './issues';
import { Layout } from 'antd';
import { ManageTagsView } from './tags';
import { PeriscopeInitiativeNotifications } from '@periscopes/notifications';
import React from 'react';
import { SalesforceReauthenticationNotification } from '@ui/notifications';
import { ScrollShadow } from '@ui/general';
import { SettingsIndex } from './settings/Index';
import { TimelineView } from '@timeline';

import { BASE_ROUTES, FULL_ROUTES, ROUTE_GROUPS } from '@sonar-software/sonar-ts-constants';
import { BulkOwnerNotification, BulkStakeholdersNotification, BulkTagNotification } from '@ui/notifications/bulk';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PeriscopeAnalysisModal, PeriscopeView } from './periscopes';

function getRootRoute(baseRoute: string): string {
	return `/${baseRoute}/*`;
}

export const AppIndex: React.FC = () =>
	<ScrollShadow
		scroller='.app-content'
		shadow='.app-header'>
		<Layout
			hasSider={ false }
			id='app'>
			<AppHeader />
			<Layout.Content className='app-content'>
				<Routes>
					<Route
						element={ <IssuesView /> }
						path={ getRootRoute(BASE_ROUTES.ISSUES) } />
					<Route
						element={ <DataSecurityView /> }
						path={ getRootRoute(BASE_ROUTES.DATA_SECURITY) } />
					<Route
						element={ <SettingsIndex /> }
						path={ getRootRoute(BASE_ROUTES.SETTINGS) } />
					<Route
						element={ <ManageTagsView /> }
						path={ getRootRoute(BASE_ROUTES.TAGS) } />
					<Route
						element={ <TimelineView /> }
						path={ getRootRoute(BASE_ROUTES.TIMELINE) } />
					<Route
						element={ <InitiativesIndex /> }
						path={ getRootRoute(BASE_ROUTES.INITIATIVES) } />
					<Route
						element={
							<FeatureRouteWrapper feature={ FeatureFlag.DataDictionary }>
								<DataDictionaryView />
							</FeatureRouteWrapper>
						}
						path={ getRootRoute(BASE_ROUTES.DATA_DICTIONARY) } />
					<Route
						element={ <PeriscopeView /> }
						path={ getRootRoute(BASE_ROUTES.PERISCOPE) } />
					{ ROUTE_GROUPS.DASHBOARD.map((path) =>
						<Route
							element={ <DashboardView /> }
							key={ path }
							path={ getRootRoute(path) } />) }
					<Route
						element={ <Navigate to={ FULL_ROUTES.DASHBOARD } /> }
						path='*' />
				</Routes>
			</Layout.Content>

			<PeriscopeAnalysisModal />
			<CreateInitiativeNotifications />
			<CreateTaskNotification />
			<PeriscopeInitiativeNotifications />
			<BulkOwnerNotification autoReset />
			<BulkStakeholdersNotification autoReset />
			<BulkTagNotification autoReset />
			<SalesforceReauthenticationNotification />
		</Layout>
	</ScrollShadow>;
